import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { propShape } from '../../../helpers/custom-prop-types';
import { compose } from '../../../helpers/recompose';
import Layout from '../../Layout';
import Breadcrumb from '../../Layout/Breadcrumb';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import ClientSeminarOneConfirmHoc from './Hoc/ClientSeminarOneCompleteHoc';
import SeminarOneTitle from './Parts/SeminarOneTitle';
/**
 * セミナー申し込み完了ページ
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SeminarOneComplete = (props) => {
    const { seminar } = props;
    const { id, information: { title }, organization: { name }, } = seminar;
    const pans = useMemo(() => [
        {
            link: '/seminar',
            text: 'セミナー',
        },
        {
            link: `/seminar/${id}/request`,
            text: title,
        },
        {
            link: '',
            text: '申し込み完了',
        },
    ], [id, title]);
    /**
     * 閉じるボタンを押したときのイベント
     * @type {(function(): void)|*}
     */
    const onClickClose = useCallback(() => {
        window.close();
    }, []);
    return (_jsxs(Layout, Object.assign({ mainClassName: 'l-main client_seminar_one' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: `${title}｜PROFFIT` }) }), _jsx(Breadcrumb, { lists: pans }), _jsx(SeminarOneTitle, { className: 'is-complete', seminar: seminar }), _jsx("div", Object.assign({ className: 'seminar_container' }, { children: _jsx("div", Object.assign({ className: 'container_complete' }, { children: _jsxs("div", Object.assign({ className: 'complete_inner' }, { children: [_jsx("div", Object.assign({ className: 'complete_title' }, { children: _jsx("div", Object.assign({ className: 'title_text' }, { children: "\u7533\u3057\u8FBC\u307F\u304C\u5B8C\u4E86\u3057\u307E\u3057\u305F" })) })), _jsxs("div", Object.assign({ className: 'complete_description' }, { children: [_jsxs("div", Object.assign({ className: 'description_top' }, { children: [`申込内容を、${name}のご担当者へ送付いたしました。`, _jsx("br", { className: 'md-is-dnone' }), `今後は、${name}から直接、ご連絡が入りますので、`, _jsx("br", { className: 'md-is-dnone' }), "\u7533\u8FBC\u3044\u305F\u3060\u3044\u305F\u30E1\u30FC\u30EB\u3092\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"] })), _jsxs("div", Object.assign({ className: 'description_bottom' }, { children: ["2\u55B6\u696D\u65E5\u5F8C\u307E\u3067\u306B\u3054\u9023\u7D61\u304C\u306A\u3044\u5834\u5408\u3001\u3010", _jsx("a", Object.assign({ className: 'link-text', href: 'mailto:support@proffit.jp' }, { children: "support@proffit.jp" })), "\u3011\u307E\u3067\u3054\u9023\u7D61\u304F\u3060\u3055\u3044\u3002"] }))] })), _jsx("div", Object.assign({ className: 'complete_action' }, { children: _jsx("button", Object.assign({ className: 'button service action_button', onClick: onClickClose, type: 'button' }, { children: "\u7533\u3057\u8FBC\u307F\u30DA\u30FC\u30B8\u3092\u9589\u3058\u308B" })) }))] })) })) }))] })));
};
SeminarOneComplete.propTypes = {
    seminar: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({
    isNotRequireCheckProfile: true,
    isProfessional: false,
}), ClientSeminarOneConfirmHoc());
export default enhance(SeminarOneComplete);
